import { Pipe, PipeTransform } from '@angular/core';
import { filter as _filter } from 'lodash-es';

@Pipe({
  name: 'filterTablesPipe',
  pure: false
})
export class FilterTablesPipe implements PipeTransform {
  // used to prepare new list with additional property like isDisplayCategory etc.
  transform(items: any[], filter: Object, selectedDatasourceType): any {
    if (selectedDatasourceType !== 'AMAZONREDSHIFT') {
        return this.handleNonAmazonRedShift(items, filter);
    }
  }

  private handleNonAmazonRedShift(items: any[], filter: Object) {
    let categoryHold = '';
        const availableTables = _filter(items, filter);

        const display = (value, flag = false) => {
        if ( value.category === categoryHold ) {
            return false;
        } else {
            const ifLabel = true;
            if (!flag) { categoryHold = value.category; }
            return ifLabel;
        }

        };

        availableTables.forEach(x => {
            x.isDisplayCategory = !x.selected && x.category !== '' && display(x);
        });
        return availableTables;
  }

}
